import UserEditPageHeader from './UserEditPageHeader';

export default UserEditPageHeader;
